'use strict';

const SchedulerAppDispatcher = require('dispatcher/SchedulerAppDispatcher'),
  EventEmitter = require('events').EventEmitter,
  Constants = require('constants/AppConstants'),
  ActionTypes = Constants.ActionTypes,
  SessionStore = require('stores/SessionStore'),
  DashboardServiceImpl = require('services/DashboardServiceImpl'),
  assign = require('object-assign'),
  DashboardAction = require('../actions/DashboardActionCreators');

const UserTaskStore = assign({}, EventEmitter.prototype, {
  
  _scheduleBoardList: [],
  _notesHasSameStateMapping: {},
  
  setScheduleBoardList(data) {
    this._scheduleBoardList = data;
  },
  
  onChangeNote(originalNote, changedNote) {
    this._notesHasSameStateMapping[originalNote.id] = this.isNoteEquals(originalNote, changedNote);
  },
  
  isAllChangesSaved() {
    return JSON.stringify(this._notesHasSameStateMapping || {}) === '{}' ||
      Object.values(this._notesHasSameStateMapping).every(value => value);
  },
  
  resetAllChangesNote() {
    this._notesHasSameStateMapping = {};
  },
  
  markAsSavedNote(task) {
    this._notesHasSameStateMapping[task.id] = true;
  },
  
  isUserTaskFetching() {
    return SessionStore.isUserTaskFetching();
  },
  
  getScheduleBoardList() {
    return this._scheduleBoardList || [];
  },
  
  emitChange() {
    this.emit('change');
  },
  
  addChangeListener(call) {
    this.addListener('change', call);
  },
  
  removeChangeListener(call) {
    this.removeListener('change', call);
  },
  
  saveChangedUserTaskName(data, onSuccess, onFailure) {
    DashboardServiceImpl.saveChangedUserTaskName(data, onSuccess, onFailure);
  },
  
  removeUserTask(data, onSuccess, onFailure) {
    DashboardServiceImpl.removeUserTask(data, onSuccess, onFailure);
  },
  
  addUserTaskName(data, onSuccess, onFailure) {
    DashboardServiceImpl.addUserTaskName(data, onSuccess, onFailure);
  },
  
  deleteUserTaskName(data, onSuccess, onFailure) {
    DashboardServiceImpl.deleteUserTaskName(data, onSuccess, onFailure);
  },
  
  fetchScheduleBoardByDate(date) {
    DashboardServiceImpl.fetchScheduleBoardByDate(date, function () {
      DashboardAction.fetchScheduleBoardByDateSuccess(JSON.parse(this.response || '{}'));
    }, function () {
      DashboardAction.fetchScheduleBoardByDateFailure();
    });
  },
  
  isNoteEquals(original, changed) {
    return original &&
      changed &&
      original.message === changed.message &&
      original.name === changed.name &&
      original.checked === changed.checked;
  }
});

UserTaskStore.dispatchToken = SchedulerAppDispatcher.register(function (action) {
  switch (action.type) {
    case ActionTypes.ADDING_NOTE_SCHEDULE_BOARD:
      SessionStore.setUserTaskFetching(true);
      UserTaskStore.addUserTaskName({
          date: action.date,
          note: action.note,
          id: action.id,
          listId: action.listId,
          listName: action.listName,
          name: action.name,
          checked: action.checked
        },
        DashboardAction.fetchScheduleBoardByDate.bind(this, action.date),
        DashboardAction.addUserTaskNameFailure
      );
      break;
    
    case ActionTypes.ADDING_NOTE_SCHEDULE_BOARD_SUCCESS:
      SessionStore.setUserTaskFetching(false);
      break;
    
    case ActionTypes.ADDING_NOTE_SCHEDULE_BOARD_FAILURE:
      SessionStore.setUserTaskFetching(false);
      UserTaskStore.emitChange();
      break;
    
    case ActionTypes.SAVING_SCHEDULE_BOARD:
      SessionStore.setUserTaskFetching(true);
      SessionStore.setUserTaskDate(action.date);
      UserTaskStore.saveChangedUserTaskName({
          date: action.date,
          name: action.name,
          id: action.id,
          originalName: action.originalName
        },
        DashboardAction.saveChangedUserTaskNameSuccess,
        DashboardAction.saveChangedUserTaskNameFailure
      );
      UserTaskStore.emitChange();
      break;
    
    case ActionTypes.SAVING_SCHEDULE_BOARD_SUCCESS:
      UserTaskStore.fetchScheduleBoardByDate(SessionStore.getUserTaskDate());
      SessionStore.setUserTaskFetching(false);
      UserTaskStore.emitChange();
      break;
    
    case ActionTypes.SAVING_SCHEDULE_BOARD_FAILURE:
      SessionStore.setUserTaskFetching(false);
      UserTaskStore.emitChange();
      break;
    
    case ActionTypes.DELETING_SCHEDULE_BOARD:
      SessionStore.setUserTaskFetching(true);
      UserTaskStore.deleteUserTaskName({id: action.id, listName: action.listName},
        DashboardAction.deleteUserTaskNameSuccess,
        DashboardAction.deleteUserTaskNameFailure
      );
      break;
    
    case ActionTypes.DELETING_SCHEDULE_BOARD_SUCCESS:
      UserTaskStore.fetchScheduleBoardByDate(SessionStore.getUserTaskDate());
      SessionStore.setUserTaskFetching(true);
      UserTaskStore.emitChange();
      break;
    
    case ActionTypes.DELETING_SCHEDULE_BOARD_FAILURE:
      SessionStore.setUserTaskFetching(false);
      UserTaskStore.emitChange();
      break;
    
    case ActionTypes.FETCH_SCHEDULE_BOARD:
      SessionStore.setUserTaskFetching(true);
      SessionStore.setUserTaskDate(action.date);
      UserTaskStore.emitChange();
      UserTaskStore.fetchScheduleBoardByDate(action.date);
      break;
    
    case ActionTypes.FETCH_SCHEDULE_BOARD_SUCCESS:
      SessionStore.setUserTaskFetching(false);
      UserTaskStore.setScheduleBoardList(action.data);
      UserTaskStore.emitChange();
      break;
    
    case ActionTypes.FETCH_SCHEDULE_BOARD_FAILURE:
      SessionStore.setUserTaskFetching(false);
      UserTaskStore.emitChange();
      break;
    
    case ActionTypes.DELETING_USER_TASK:
      UserTaskStore.removeUserTask(
        {id: action.id, listId: action.listId},
        DashboardAction.fetchScheduleBoardByDate.bind(this, SessionStore.getUserTaskDate()),
        DashboardAction.removeUserTaskFailure
      );
      break;
    
    case ActionTypes.DELETING_USER_TASK_SUCCESS:
      break;
    
    case ActionTypes.DELETING_USER_TASK_FAILURE:
      SessionStore.setUserTaskFetching(false);
      UserTaskStore.emitChange();
      break;
    
  }
});

module.exports = UserTaskStore;


/** WEBPACK FOOTER **
 ** ./src/stores/UserTaskStore.js
 **/